var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VRemoteSelect',_vm._g(_vm._b({attrs:{"item-value":"id","item-selected":"account","item-text":(c) => (`${c.account}-${c.team_name}`),"find_api":_vm.$util.api.find_customer,"search_api":_vm.$util.api.customer_select_search,"item-default":{id: 0, account: '', team_name: ''}}},'VRemoteSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }